const ROOT = 'https://inner.wei-group.net/proteinFunction';
// const ROOT = 'https://server.wei-group.net/biology';

// const ROOT = 'https://tutorial.wzhqwq.xyz/cors/wei';
export const JOBINFO = `${ROOT}/job/info`;
export const JOBSUB = `${ROOT}/job/submit`;
export const JOBLIST = `${ROOT}/job/list`;